import { motion } from "framer-motion";

import { navigationVariants } from "../variants";
import MenuItem from "./MenuItem";
import { navLinks } from "layouts/PageLayout/navLinks";

export const Navigation = () => (
  <motion.ul variants={navigationVariants}>
    {navLinks.map((link, key) => (
      <MenuItem {...link} key={key} />
    ))}
  </motion.ul>
);

export default Navigation;
